import React from 'react';
export function HeroSection() {
  return <section className="pt-28 pb-16 md:pt-32 md:pb-24 bg-gray-50" data-id="element-122">
      <div className="container mx-auto px-4" data-id="element-123">
        <div className="flex flex-col md:flex-row items-center" data-id="element-124">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10" data-id="element-125">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-126">
              Impulsamos tu presencia digital con resultados reales.
            </h1>
            <p className="text-lg text-gray-700 mb-8" data-id="element-127">
              Desarrollamos estrategias de marketing y sitios web optimizados
              para hacer crecer tu negocio online.
            </p>
            <a href="https://wa.me/5491150026793" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-8 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors inline-block" data-id="element-128">
              Hablemos hoy
            </a>
          </div>
          <div className="md:w-1/2" data-id="element-129">
            <img src="https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Equipo trabajando en estrategia digital" className="w-full h-auto rounded-lg shadow-lg" data-id="element-130" />
          </div>
        </div>
      </div>
    </section>;
}